/* PDP clone kit – a carousel moved by its buttons only: the track shifts by (85% of its width + 16 px) per slide and
   goes round at both ends, the original's rule. Used by sections/pdp-cards.liquid. */
(function () {
  'use strict';
  var PDP = window.PDP || {};
  var define = PDP.define || function (n, c) { if (window.customElements && !customElements.get(n)) customElements.define(n, c); };
  define('pdp-slider', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this._ready) return;
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this._ready = true;
      this.n = this.track.querySelectorAll('[data-slide]').length;
      this.i = 0;
      var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.i === 0 ? self.n - 1 : self.i - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.i === self.n - 1 ? 0 : self.i + 1); });
    }
    go(i) {
      this.i = i;
      this.track.style.transform = 'translateX(calc(-' + i + ' * (' + (this.dataset.step || 85) + '% + ' + (this.dataset.gap || 16) + 'px)))';
    }
  });
})();
